// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay-coin-icon{width:.37333rem;height:.37333rem}", ""]);
// Exports
module.exports = exports;
